import { fontSizes } from "../sizes";

const baseStyle = {
  color: "fg-main",
};

// Used: xs, sm, md, lg, xl
const sizes = {
  "2xl": { fontSize: [fontSizes.sm, fontSizes.sm, fontSizes.x1l] },
  xl: { fontSize: fontSizes.md },
  lg: { fontSize: [fontSizes.sm, fontSizes.sm, fontSizes.md] },
  md: { fontSize: [fontSizes.x1s, fontSizes.x1s, fontSizes.md] },
  sm: { fontSize: fontSizes.sm },
  xs: { fontSize: [fontSizes.x1s, fontSizes.x1s, fontSizes.sm] },
  // Temporary solution until overall sizes refactor; th-Timea Hopp
  "th-lg": { fontSize: ["1rem", "1rem", "1.125rem"] }, // 16px; 18px
};

const variants = {
  "body-default": {
    fontSize: "1rem",
    fontWeight: "normal",
    lineHeight: "133%",
  },
  mono: {
    fontFamily: "Moderat Mono",
    fontWeight: "light",
  },
  monoBold: {
    fontFamily: "Moderat Mono",
    fontWeight: "bold",
  },
  "small-print": {
    fontSize: "0.75rem",
    fontWeight: "normal",
    lineHeight: "150%",
  },
  subheading: {
    fontSize: "1.5rem",
    fontWeight: "normal",
    lineHeight: "130%",
    textAlign: "center",
    w: ["100%", "100%", "3xl"],
  },
  "th-body1": {
    fontFamily: "Moderat",
    fontSize: "1.125rem", // 18px
    lineHeight: "140%",
    letterSpacing: "0",
  },
  "th-body2": {
    fontFamily: "Moderat",
    fontSize: "1rem", // 16px
    lineHeight: "140%",
    letterSpacing: "0",
  },
  "th-body3": {
    fontFamily: "Moderat",
    fontSize: "0.875rem",
    lineHeight: "140%",
    letterSpacing: "0",
  },
  "th-body4": {
    fontFamily: "Moderat",
    fontSize: "0.75rem",
    lineHeight: "140%",
    letterSpacing: "0",
  },
  "th-t1": {
    fontFamily: "Moderat",
    fontWeight: "medium",
    fontSize: "1rem",
    lineHeight: "120%",
    letterSpacing: "0.75px",
    textTransform: "uppercase",
  },
  "th-t2": {
    fontFamily: "Moderat",
    fontWeight: "medium",
    fontSize: "0.875rem",
    lineHeight: "120%",
    letterSpacing: "0.75px",
    textTransform: "uppercase",
  },
  "th-t3": {
    fontFamily: "Moderat",
    fontWeight: "medium",
    fontSize: "0.75rem",
    lineHeight: "120%",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
  },
  "th-t4": {
    fontFamily: "Moderat",
    fontWeight: "medium",
    fontSize: "0.625rem",
    lineHeight: "120%",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
  },
};

export const Text = {
  baseStyle,
  sizes,
  variants,
};
